export default __webpack_public_path__ + "static/294-296251069130a593d71e0579fe657f6d.gif";